import { HStack } from "@chakra-ui/react";
import { CountryCodeEnum } from "gen/model/countryCodeEnum";
import { StateCodeEnum } from "gen/model/stateCodeEnum";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { usePrefixedFieldName } from "shared/components/form/FormFieldPrefix";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { enumKeys } from "shared/utils/EnumUtils";

export interface FormJurisdictionSelectProps {
  countryFieldName?: string;
  countryFieldTitle?: string;
  stateFieldName?: string;
  stateFieldTitle?: string;
}

export const FormJurisdictionSelect: React.FC<FormJurisdictionSelectProps> = ({
  countryFieldName = "jurisdiction_country",
  stateFieldTitle,
  stateFieldName,
  countryFieldTitle,
}) => {
  const form = useFormContext();
  const prefixedCountryFieldName = usePrefixedFieldName(countryFieldName);
  const country = form.watch(prefixedCountryFieldName);
  return (
    <HStack spacing="14px" alignItems="flex-start">
      <JurisdictionCountryCodeFormSelect
        name={countryFieldName}
        title={countryFieldTitle}
      />
      {country === CountryCodeEnum.USA && (
        <JurisdictionStateCodeFormSelect
          name={stateFieldName}
          title={stateFieldTitle}
        />
      )}
    </HStack>
  );
};

const JurisdictionCountryCodeFormSelect: React.FC<{
  name?: string;
  title?: string;
}> = ({ name, title }) => {
  const { t } = useTranslation(["address", "enums"]);
  return (
    <FormSelect
      name={name ?? "jurisdiction_country"}
      title={title ?? t("address:jurisdictionCountry")}
      unsetWhenEmpty={true}
    >
      {enumKeys(CountryCodeEnum).map((countryCode) => (
        <SelectOption key={countryCode} value={countryCode}>
          {t(`enums:CountryCodeEnum.${countryCode}`)}
        </SelectOption>
      ))}
    </FormSelect>
  );
};

const JurisdictionStateCodeFormSelect: React.FC<{
  name?: string;
  title?: string;
}> = ({ name, title }) => {
  const { t } = useTranslation(["address", "enums"]);
  return (
    <FormSelect
      name={name ?? "jurisdiction_state"}
      title={title ?? t("address:jurisdictionState")}
    >
      {enumKeys(StateCodeEnum).map((stateCode) => (
        <SelectOption key={stateCode} value={stateCode}>
          {t(`enums:StateCodeEnum.${stateCode}`)}
        </SelectOption>
      ))}
    </FormSelect>
  );
};
